(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lieferzeit"] && !Shopify.designMode) return;
  try {
    (()=>{function shDeliveryDate(now, count=3){
const values=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).map(p=>[p.type,p.value]));
const date=new Date(Date.UTC(Number(values.year),Number(values.month)-1,Number(values.day),12));
const cache=new Map();
const holidays=year=>{
if(cache.has(year))return cache.get(year);
const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
const easter=new Date(Date.UTC(year,Math.floor(n/31)-1,n%31+1,12));
const set=new Set(['01-01','01-06','05-01','08-15','10-03','11-01','12-25','12-26'].map(day=>year+'-'+day));
for(const offset of [-2,1,39,50,60]){const day=new Date(easter);day.setUTCDate(day.getUTCDate()+offset);set.add(day.toISOString().slice(0,10))}
cache.set(year,set);return set;
};
let remaining=count;
while(remaining>0){date.setUTCDate(date.getUTCDate()+1);if(date.getUTCDay()>0&&date.getUTCDay()<6&&!holidays(date.getUTCFullYear()).has(date.toISOString().slice(0,10)))remaining--}
return date;
}
const sync=()=>{const date=shDeliveryDate(new Date());const iso=date.toISOString().slice(0,10);const label=['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'][date.getUTCDay()]+', den '+String(date.getUTCDate()).padStart(2,'0')+'.'+String(date.getUTCMonth()+1).padStart(2,'0')+'.';document.querySelectorAll('[id^="cart-sections"] .sh-delivery-estimate time').forEach(time=>{if(time.dateTime!==iso)time.dateTime=iso;if(time.textContent!==label)time.textContent=label})};document.querySelectorAll('[id^="cart-sections"]').forEach(root=>new MutationObserver(sync).observe(root,{childList:true,subtree:true}));sync();document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync()});setInterval(sync,60000)})();
  } catch(e) { console.error(e); }
})();

})();
